import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';

$(function () {
  $('.header__wrapper').waypoint(
    (direction) => {
      const $stickyHeader = $('.header-sticky');

      if (direction === 'down') {
        $stickyHeader.css('display', 'flex').addClass('fadeIn');
      } else if (direction === 'up') {
        $stickyHeader.fadeOut(100, 'linear').removeClass('fadeIn');
      }
    },
    { offset: -100 }
  );
});
